import { group, control } from "@reactables/forms";

export const eligibilityQuestions = group({
  controls: {
    excludedActivities: control(["", "required"]),
  },
  validators: ["eligibility"],
});
